<template lang="pug">
Row.modal-row(type="flex" :gutter="16")
    //- 左側的 Builder
    Col.modal-col(:span="showPreviewSection ? 16 : 24")
        h4.modal-col-title(v-if="showPreviewSection") {{ titlePrefix }}{{ $t("wafrules.segmentBuilder") }}
        section.modal-col-builder
            //- 最前面的新增按鈕
            InsertButton(
                :target-field="field"
                :target-field-rule="fieldRule"
                :insert-index="0"
                :is-inserting="isInserting(0)"
                @on-prepare="onPrepare"
                @on-insert="onInsert"
            )
            //- 每一段 Segment
            template(v-for="(segment, segmentIndex) in segments")
                Tag(
                    :key="segmentIndex"
                    :color="segment.type === 'system' ? 'success' : 'default'"
                    closable
                    @on-close="onRemove(segmentIndex)"
                ) {{ getTagContent(segment) }}
                //- 每一段 Segment 後面的新增按鈕
                InsertButton(
                    :target-field="field"
                    :target-field-rule="fieldRule"
                    :insert-index="segmentIndex + 1"
                    :is-inserting="isInserting(segmentIndex + 1)"
                    @on-prepare="onPrepare"
                    @on-insert="onInsert"
                )
    //- 右側的預覽區塊
    Col.modal-col(v-if="showPreviewSection" span="8")
        h4.modal-col-title {{ titlePrefix }}{{ $t("wafrules.preview") }}
        section.modal-col-preview
            template(v-for="segment in segments")
                span {{ previewRowContent(segment) }}
</template>

<script>
import InsertButton from "./InsertButton.vue";

export default {
    name: "Builder",
    components: { InsertButton },
    props: {
        field: { type: String, required: true },
        fieldRule: { type: Object, default: () => ({}) },
        titlePrefix: { type: String, default: "" },
        activeInsertIndex: { type: Number, default: null },
        activeInsertField: { type: String, default: "" },
        segments: { type: Array, default: () => [] },
        showPreviewSection: { type: Boolean, default: true },
    },
    methods: {
        isInserting(index) {
            return this.activeInsertIndex === index && this.activeInsertField === this.field;
        },
        onPrepare(payload) {
            this.$emit("on-prepare", payload);
        },
        onInsert(payload) {
            this.$emit("on-insert", payload);
        },
        getTagContent(s) {
            return s.type === "system" ? `VAR: ${s.value}` : s.value;
        },
        onRemove(index) {
            this.$emit("on-remove", { field: this.field, index });
        },
        previewRowContent(segment) {
            return segment.type === "system" ? `{${segment.value}}` : segment.value;
        },
    },
};
</script>

<style scoped>
.modal-row {
    margin-bottom: 16px;
}
.modal-col {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}
.modal-col-title {
    margin-bottom: 6px;
}
.modal-col-builder,
.modal-col-preview {
    flex: 1;
    box-sizing: border-box;
    padding: 14px;
    border-radius: 6px;
}
.modal-col-builder {
    border: 1px solid #dcdee2;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
}
.modal-col-preview {
    background: #efefef;
    word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/SegmentBuilder/Builder.vue